export function getComponentMeta(compType): { inputs, outputs } {
    const props = compType.ɵcmp;
    const inputs = [];
    const outputs = [];
    let inputObj = props["inputs"];
    let outputObj = props["outputs"];
    for (const prop in inputObj) {
        inputs.push(inputObj[prop]);
    }
    for (const prop in outputObj) {
        outputs.push(outputObj[prop]);
    }

    // for (const prop in props) {
    //     const member = props[prop][0];
    //     if (member.ngMetadataName === 'Input') {
    //         inputs.push(prop);
    //     } else if (member.ngMetadataName === 'Output') {
    //         outputs.push(prop);
    //     }
    // }
    return {
        inputs: inputs.sort(),
        outputs: outputs.sort()
    };
}